export const LOCAL_STORAGE_KEYS = {
  ACCESS_TOKEN : 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  USER_ID      : 'userId'
}

export const getAccessToken = () => localStorage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN)
export const getRefreshToken = () => localStorage.getItem(LOCAL_STORAGE_KEYS.REFRESH_TOKEN)
export const getUserId = () => localStorage.getItem(LOCAL_STORAGE_KEYS.USER_ID)
